import { render, staticRenderFns } from "./AccountingData.vue?vue&type=template&id=db1fada4&scoped=true&"
import script from "./AccountingData.vue?vue&type=script&lang=js&"
export * from "./AccountingData.vue?vue&type=script&lang=js&"
import style0 from "./AccountingData.vue?vue&type=style&index=0&id=db1fada4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1fada4",
  null
  
)

export default component.exports